module.exports = __webpack_public_path__ + "a3c60458ab5fde98411e6e4bf3aa0eb6.png";